import React from 'react'
import classNames from 'classnames'
import _ from 'lodash'
import axios from 'axios'
import immutable from 'immutable'

import {ImageThumb} from './layout/imagethumb.component'
import {RelatedContentResults} from './relatedcontentband/relatedcontentresults.component'

export class PromotedRegionBand extends React.Component {
    constructor(props) {
        super(props)

        this._isMounted = false

        this.state = {
            isLoaded: false,
            hasError: false,
            results: null,
            region: null
        }
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    componentDidMount() {
        this._isMounted = true

        let self = this
        // Do our search
        axios.get('/api/v1/promoted-regions/' + self.props.region, {
            params: {
                with: 'images'
            }
        })
            .then(function(response) {
                if (typeof response.data !== 'undefined') {
                    if (self._isMounted && response.data.destinations.length > 0) {
                        let tRegion = new immutable.fromJS(response.data)
                        self.setState({region: tRegion, results: response.data.destinations, isLoaded: true})
                    }
                }
            })
            .catch(function(error) {
                // console.log("Error getting region content")
                // console.log(error)
            })
    }

    render() {
        if (this.state.isLoaded && this.state.results.length > 0) {
            return (
                <div className="view-area">
                    <div className="view-left-col"/>
                    <div className="view-center">
                        <div className="regional-band">
                            <div className="region-header">
                                <ImageThumb type="promoted-region" item={this.state.region}/>
                                <h2>{ this.state.region.get('name') }</h2>
                            </div>
                            <div className="region-description">
                                <p>{this.state.region.get('description')}</p>
                            </div>
                            <RelatedContentResults results={this.state.results} region={this.state.region.get('name') } showDetails={this.props.showDetails} model="destination" type="regional"/>
                        </div>
                    </div>
                    <div className="view-right-col"/>
                </div>
            )
        } else {
            return null
        }
    }
}
